export const PRESCRIPTION_ENABLED = 'prescriptionEnabled'
export const PRESCRIPTION_MANUAL_ENABLED = 'prescriptionManualEnabled'
export const PRESCRIPTION_UPLOAD_ENABLED = 'prescriptionUploadEnabled'
